import { Button } from "@lyfegen-platform/react-common";
import { Theme, useTheme } from "@material-ui/core";
import { TFunction, useTranslation } from "react-i18next";
import LyfeTooltip from "../LyfeTooltip";
import AgreementStatus from "./new/AgreementStatus";
import CaseStatus from "./new/CaseStatus";
import FormStatus from "./new/FormStatus";
import InvoiceStatus from "./new/InvoiceStatus";
import PublicAgreementStatusComponent from "./new/PublicAgreementStatus";
import RecordsStatus from "./new/RecordsStatus";
import { IProps } from "./types";
import RefundStatusComponent from "./new/RefundStatus";

const components = {
	FormsStatusComponent: (props: any, children: React.ReactNode, palette: Theme["palette"], t: TFunction<"translation">) => (
		<FormStatus props={props} children={children} palette={palette} t={t} />
	),
	AgreementStatusComponent: (props: any, children: React.ReactNode, palette: Theme["palette"], t: TFunction<"translation">) => (
		<AgreementStatus props={props} children={children} palette={palette} t={t} />
	),
	RefundStatusComponent: (props: any, children: React.ReactNode, palette: Theme["palette"], t: TFunction<"translation">) => (
		<RefundStatusComponent props={props} children={children} palette={palette} t={t} />
	),
	InvoiceStatusComponent: (props: any, children: React.ReactNode, palette: Theme["palette"], t: TFunction<"translation">) => (
		<InvoiceStatus props={props} children={children || props.children} palette={palette} t={t} />
	),
	CaseStatusComponent: (props: any, children: React.ReactNode, palette: Theme["palette"], t: TFunction<"translation">) => (
		<CaseStatus props={props} palette={palette} t={t} />
	),
	PublicAgreementStatusComponent: (props: any, children: React.ReactNode, palette: Theme["palette"], t: TFunction<"translation">) => (
		<PublicAgreementStatusComponent props={props} palette={palette} t={t} />
	),
	Tooltip: (props: any, children: React.ReactNode) => <LyfeTooltip {...props} children={children || props.children} />,
	CreateNewCaseButton: (props: any, children: any) => (
		<Button
			onMouseDown={props.handleClick}
			onKeyDown={(event) => event.key === "Enter" && props.handleClick()}
			onTouchEnd={props.handleClick}
			disabled={props.disabled}
			color="primary"
			use="add"
		>
			{children}
		</Button>
	),
	RecordStatus: (props: any, children: React.ReactNode, palette: Theme["palette"], t: TFunction<"translation">) => (
		<RecordsStatus props={props} children={children} palette={palette} t={t} />
	),
};

const MappedComponent: React.FC<IProps> = ({ component, props, children }) => {
	const { t } = useTranslation();
	const { palette } = useTheme();

	return components[component](props, children, palette, t) as any;
};

export default MappedComponent;
